module.exports = __webpack_public_path__ + "static/media/settings.621ca7bc.svg";